import React from 'react';
import { RecordColumn, RecordList } from 'components/record-shell/RecordList';
import { moneyFormat } from 'helpers/moneyFormat';
import { SupplierProduct } from 'types/supplier';

interface SupplierProductsListProps {
  products: SupplierProduct[];
  handleDeleteProduct(product: SupplierProduct, index: number): void;
  handleEditProduct(product: SupplierProduct, index: number): void;
}

const columns: RecordColumn[] = [
  { id: 'product', label: 'Produto' },
  { id: 'unit', label: 'Un.' },
  { id: 'cost', label: 'Custo', align: 'right', width: '110px' },
  { id: 'min', label: 'Venda mín.', shortLabel: 'Mín', align: 'right', width: '110px' },
  { id: 'max', label: 'Venda máx.', shortLabel: 'Máx', align: 'right', width: '110px' },
];

const SupplierProductsList: React.FC<SupplierProductsListProps> = ({
  products,
  handleDeleteProduct,
  handleEditProduct,
}) => (
  <RecordList
    columns={columns}
    rows={products.map((product, index) => ({
      key: product.id || index,
      values: {
        product: product.product_name,
        unit: product.product_unit || '-',
        cost: moneyFormat(product.cost_price),
        min: moneyFormat(product.sale_price_min),
        max: moneyFormat(product.sale_price_max),
      },
    }))}
    onEdit={index => handleEditProduct(products[index], index)}
    onDelete={index => handleDeleteProduct(products[index], index)}
  />
);

export default SupplierProductsList;
